const Category = [
  "Total sperm concentration",
  "Percentage motility",
  "Grade A",
  "Grade B",
  "Grade C",
  "Vitality ",
  "Agglutination",
  "Pus cells",
  "Red Blood cells",
  "Epithelial cells",
];

export default Category;
